import { FormGroup } from '@angular/forms';
import { STATES } from '@tangilla/tg-ng-models';
import { WidgetJson } from '../widget.json';

export class AddressFormWidgetJson extends WidgetJson {
  getWidgetJson(form: FormGroup) {
    return {
      wrapperClass: 'row',
      questions: [
        {
          'type': 'text',
          'name': this.model?.jsonObj?.namesReplacements?.addressLine1 || 'ccaddress1',
          'includeInOutput': this.shouldIncludeInOutput('addressLine1'),
          'maxLength': 30,
          'title': this.model?.jsonObj?.labelsReplacements?.addressLine1 || 'Address Line 1',
          'defaultValue': '{h_address1}',
          'requiredErrorText': 'required',
          'isRequired': true,
          class: this.model?.jsonObj.excludeFields?.includes('addressLine2') ? 'col-12' : 'col-sm-12 col-md-8',
          formControl: form.get('addressLine1'),
          controlName: 'addressLine1'
        },
        {
          'type': 'text',
          'name': this.model?.jsonObj?.namesReplacements?.addressLine2 || 'ccaddress2',
          'includeInOutput': this.shouldIncludeInOutput('addressLine2'),
          exclude: this.model?.jsonObj.excludeFields?.includes('addressLine2'),
          'maxLength': 30,
          'title': this.model?.jsonObj?.labelsReplacements?.addressLine2 || 'Address Line 2',
          'defaultValue': '{h_address2}',
          'requiredErrorText': 'required',
          'isRequired': false,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('addressLine2'),
          controlName: 'addressLine2'
        },
        {
          'type': 'text',
          'name': this.model?.jsonObj?.namesReplacements?.city || 'cccity',
          'title': this.model?.jsonObj?.labelsReplacements?.city || 'City',
          'includeInOutput': this.shouldIncludeInOutput('city'),
          'width': '350px',
          'defaultValue': '{h_city}',
          'requiredErrorText': 'required',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('city'),
          controlName: 'city'
        },
        {
          'type': 'dropdown',
          'name': this.model?.jsonObj?.namesReplacements?.state || 'ccstate',
          'title': this.model?.jsonObj?.labelsReplacements?.state || 'State',
          'width': '150px',
          'includeInOutput': this.shouldIncludeInOutput('state'),
          'startWithNewLine': false,
          'defaultValue': '{h_state}',
          'requiredErrorText': 'required',
          'isRequired': true,
          class: 'col-sm-12 col-md-4',
          'choices': STATES.map(state => {
            return {
              value: state,
              label: state
            };
          }),
          formControl: form.get('state'),
          controlName: 'state'
        },
        {
          'type': 'text',
          'name': this.model?.jsonObj?.namesReplacements?.zip5 || 'cczip',
          'title': this.model?.jsonObj?.labelsReplacements?.zip5 || 'Zip',
          'includeInOutput': this.shouldIncludeInOutput('zip5'),
          'mask': '99999',
          'placeholder': '_____',
          'width': '120px',
          'defaultValue': '{h_zip}',
          'requiredErrorText': 'required',
          'maxLength': 5,
          'isRequired': true,
          'startWithNewLine': false,
          class: 'col-sm-12 col-md-4',
          formControl: form.get('zip5'),
          controlName: 'zip5'
        }]
    };
  }
};
